import { useEffect, useState } from "react";
import {
  ICoach,
  ICoachAvailability,
  ICoachBooking,
  ICoachIntervalItem,
  ICourt,
} from "../../types/api";
import "./AdminHandleCoaches.scss";
import { useNavigate } from "react-router-dom";
import { ROUTE } from "../../shared/enums";
import WeekDaySelector from "../../hoc/DatePicker/Datepicker";
import CreateCoachPopup from "../../containers/Coaches/CreateCoachPopup/CreateCoachPopup";
import {
  listCoaches,
  listCoachesAvailability,
} from "../../api/coaches/coaches";
import Spinner from "../../components/UI/Spinner/Spinner";
import { toast } from "react-toastify";
import EditCoachPopup from "../../containers/Coaches/EditCoachPopup/EditCoachPopup";
import CoachShowBookedInfoPopup from "../../containers/Coaches/ CoachShowBookedInfoPopup/ CoachShowBookedInfoPopup";
import { CognitoUser } from "../../types/cognito";
import { Auth } from "aws-amplify";
import { combinedQuery } from "../../api/combinedQueries/combinedQueries";
import { formatToIsoDate, isToday } from "../../shared/dateUtils";

function AdminHandleCoaches() {
  const navigate = useNavigate();

  const [hideEmptySchedules, setHideEmptySchedules] = useState<boolean>(
    () => localStorage.getItem("hideEmptyCoachSchedules") === "true",
  );

  useEffect(() => {
    localStorage.setItem(
      "hideEmptyCoachSchedules",
      String(hideEmptySchedules),
    );
  }, [hideEmptySchedules]);
  const [coaches, setCoaches] = useState<ICoach[]>([]);
  const [courts, setCourts] = useState<ICourt[]>([]);
  const [currentEditCoachId, setCurrentEditCoachId] = useState<string>("");
  const [showEditCoachPopup, setShowEditCoachPopup] = useState<boolean>(false);
  const [coachesAvailability, setCoachesAvailability] = useState<
    ICoachAvailability[]
  >([]);
  const [user, setUser] = useState<CognitoUser | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [showBookedInfoPopup, setShowBookedInfoPopup] =
    useState<boolean>(false);
  const [bookingToShow, setBookingToShow] = useState<ICoachBooking>();
  const [showCreateCoachPopup, setShowCreateCoachPopup] =
    useState<boolean>(false);
  const [filterDate, setFilterDate] = useState(() => {
    const storedDate = localStorage.getItem("filterDate");
    return storedDate ? new Date(storedDate) : new Date();
  });

  useEffect(() => {
    Auth.currentAuthenticatedUser()
      .then((userData) => {
        setUser(userData);
      })
      .catch((error: any) => {
        toast.error(error);
      });
  }, []);

  const fetchCoachesAvailability = async (date: Date) => {
    try {
      const coachesAvailabilityResponse = await listCoachesAvailability(
        formatToIsoDate(date)
      );
      if (
        coachesAvailabilityResponse &&
        coachesAvailabilityResponse.length > 0 &&
        "message" in coachesAvailabilityResponse[0] === false
      ) {
        setCoachesAvailability(coachesAvailabilityResponse);
      } else {
        // No availability for this date — reset so we never render the
        // previously selected date's data.
        setCoachesAvailability([]);
      }
    } catch (error) {
      setCoachesAvailability([]);
      toast.error("Error fetching coaches availability");
    }
  };

  // const fetchCoaches = async () => {
  //   try {
  //     const coachesResponse = await listCoaches("admin");
  //     if (
  //       coachesResponse &&
  //       coachesResponse.length > 0 &&
  //       "message" in coachesResponse[0] === false
  //     ) {
  //       setCoaches(coachesResponse);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching coaches:", error);
  //   }
  // };

  const fetchChosenItems = async ({
    fetchCourts = false,
    fetchCoaches = false,
  }) => {
    setLoading(true);
    if (!user) return;
    try {
      const response = await combinedQuery({
        active: true,
        requestor: "admin",
        date: formatToIsoDate(filterDate),
        fetchCourts: fetchCourts,
        fetchCoaches: fetchCoaches,
      });

      if (
        fetchCoaches &&
        response.coaches &&
        !("message" in response.coaches)
      ) {
        setCoaches(response.coaches);
      }
      if (fetchCourts && response.courts && !("message" in response.courts)) {
        setCourts(response.courts);
      }

      setLoading(false);
    } catch (error: any) {
      toast.error(error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchChosenItems({
      fetchCourts: true,
      fetchCoaches: true,
    });
  }, [user]);

  useEffect(() => {
    localStorage.setItem("filterDate", formatToIsoDate(filterDate));
    fetchCoachesAvailability(filterDate);
  }, [filterDate]);

  const openEditCoach = (coachId: string) => {
    setCurrentEditCoachId(coachId);
    setShowEditCoachPopup(true);
  };

  const openCreateCoach = () => {
    setShowCreateCoachPopup(true);
  };

  const handleShowBookingInfoPopup = (booking: ICoachBooking) => {
    setBookingToShow(booking);
    setShowBookedInfoPopup(true);
  };
  const generateSlotsForInterval = (interval: ICoachIntervalItem) => {
    const start = interval.start_time;
    const end = interval.end_time;
    const slots = [];
    slots.push(`${start.slice(0, 5)} - ${end.slice(0, 5)}`);

    const booker = interval.booking?.member_name;
    const nameString =
      booker && booker.length > 16 ? `${booker.substring(0, 16)}..` : booker;
    if (interval.booking) {
      return (
        <tr>
          <td
            className="booked pointer"
            onClick={() =>
              handleShowBookingInfoPopup(interval.booking as ICoachBooking)
            }
          >
            {slots.map((slot, index) => (
              <div key={index} className="time-item-wrapper slot-booked ">
                <div className="time-content-wrapper">
                  <div>{slot}</div>
                  <div>{nameString}</div>
                </div>
              </div>
            ))}
          </td>
        </tr>
      );
    }

    return (
      <tr>
        <td>
          {slots.map((slot, index) => (
            <div key={index} className="time-item-wrapper">
              <div className="time-content-wrapper">
                <div key={index}>{slot}</div>
              </div>
            </div>
          ))}
        </td>
      </tr>
    );
  };

  const intervalsFor = (coachId: string) =>
    coachesAvailability.find((a) => a.coach_id === coachId)?.intervals ?? [];

  const visibleCoaches = hideEmptySchedules
    ? coaches.filter((coach) => intervalsFor(coach.coach_id).length > 0)
    : coaches;

  // Always A-Z by the name shown in the header, whatever the day's bookings
  // or availability look like, so a coach's column is where it was yesterday.
  const coachName = (coach: ICoach) => `${coach.first_name} ${coach.last_name}`;
  const sortedCoaches = [...visibleCoaches].sort((a, b) =>
    coachName(a).localeCompare(coachName(b), "sv", { sensitivity: "base" })
  );

  const coachActions = (coachId: string) => (
    <span className="coach-header-actions">
      <i
        className="fa-regular fa-pen-to-square pointer"
        title="Redigera tränare"
        onClick={() => openEditCoach(coachId)}
      ></i>
      <i
        className="fa-regular fa-calendar-week pointer"
        title="Öppna schema"
        onClick={() => navigate(`${ROUTE.Coach}/${coachId}`)}
      ></i>
    </span>
  );

  if (!coaches && !courts && !coachesAvailability && !loading)
    return <Spinner />;
  return (
    <div className="admin-handle-coaches-layout">
      <h1 className="text-l primary-text">Tränare</h1>
      <div className="handle-coaches-actions-wrapper">
        <div className="coaches-weekday-selector-wrapper">
          <WeekDaySelector
            value={filterDate}
            onChange={setFilterDate}
            includeWeekdays
            textM
          />
          {!isToday(filterDate) && (
            <a onClick={() => setFilterDate(new Date())}>Till idag</a>
          )}
        </div>
        <div className="coaches-add-wrapper">
          <div className="coaches-hide-empty">
            <span className="text-m secondary-text">Göm tomma scheman</span>
            <label className="toggle text-m">
              <input
                type="checkbox"
                checked={hideEmptySchedules}
                onChange={(e) => setHideEmptySchedules(e.target.checked)}
              />
              <span className="slider round"></span>
            </label>
          </div>
          <button
            className="coaches-add-button text-m"
            onClick={() => openCreateCoach()}
          >
            Lägg till ny tränare
          </button>
        </div>
      </div>
      <div className="coaches-table-overflow-wrapper">
        {/* Fixed layout so every coach gets the same width whether or not they
            have any availability that day — with auto layout a single booked
            slot made one column swallow the row. The floor keeps columns
            readable and lets the wrapper scroll once there are too many
            coaches to fit. */}
        <table
          className="coaches-table"
          style={{ minWidth: Math.max(sortedCoaches.length, 1) * 260 }}
        >
          <thead>
            <tr>
              {sortedCoaches.map((coach, index) => (
                <th key={index} className="text-m secondary-text">
                  <div className="coach-header">
                    <span className="coach-header-name">
                      {coach.first_name} {coach.last_name} ({coach.coach_id})
                    </span>
                    {coachActions(coach.coach_id)}
                  </div>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            <tr>
              {sortedCoaches.map((coach) => {
                const coachAvailability = coachesAvailability.find(
                  (availability) => availability.coach_id === coach.coach_id
                );
                return (
                  <td key={coach.coach_id}>
                    {coachAvailability
                      ? coachAvailability.intervals.map((interval, index) => (
                          <table
                            className="nested-admin-coach-times-table text-s secondary-text"
                            key={index}
                          >
                            <tbody>{generateSlotsForInterval(interval)}</tbody>
                          </table>
                        ))
                      : null}
                  </td>
                );
              })}
            </tr>
          </tbody>
        </table>
      </div>

      <CreateCoachPopup
        showPopup={showCreateCoachPopup}
        onClose={() => setShowCreateCoachPopup(false)}
        onConfirm={() =>
          fetchChosenItems({
            fetchCoaches: true,
          })
        }
      />
      <EditCoachPopup
        showPopup={showEditCoachPopup}
        onClose={() => setShowEditCoachPopup(false)}
        onConfirm={() =>
          fetchChosenItems({
            fetchCoaches: true,
          })
        }
        coach={coaches.find((coach) => coach.coach_id === currentEditCoachId)}
      />
      <CoachShowBookedInfoPopup
        showPopup={showBookedInfoPopup}
        onClose={() => setShowBookedInfoPopup(false)}
        onConfirm={() => {
          fetchCoachesAvailability(filterDate);
        }}
        booking={bookingToShow}
        courts={courts}
      />
    </div>
  );
}

export default AdminHandleCoaches;
